var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-form-group',{attrs:{"title":_vm.$t('title')}},[_c('t-text-input',{attrs:{"disabled":""},model:{value:(_vm.controLevelName),callback:function ($$v) {_vm.controLevelName=$$v},expression:"controLevelName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }